import {useContext} from "react";
import {Snack, Snackbar} from "@nike/eds";
import React from "react";
import SnackbarContext, {SnackbarStatus} from "./SnackbarContext";

export function ApplicationSnackbar() {

    const snackbarCtx = useContext(SnackbarContext);

    return (
        <Snackbar id="cchSnackbar" className="eds-color--text-default">
            {(() => {
                if (snackbarCtx.status === SnackbarStatus.success) {
                    return (
                        <Snack id="success" status="success" onDismiss={snackbarCtx.onClose}>
                            {snackbarCtx.msg}
                        </Snack>
                    )
                } else if (snackbarCtx.status === SnackbarStatus.error) {
                    return (
                        <Snack id="error" status="error" onDismiss={snackbarCtx.onClose}>
                            {snackbarCtx.msg}
                        </Snack>
                    )
                } else {
                    return (
                        <Snack id="neutral" status="neutral" onDismiss={snackbarCtx.onClose}>
                            {snackbarCtx.msg}
                        </Snack>
                    )
                }
            })()}
        </Snackbar>

    )
}
